import { useMemo } from 'react'

import { StringUtils } from '@space-lib/utils/string'
import Avatar from '@space-shell/common/components/avatar'

export type NotificationAvatarProps = {
  userName: string
  userCode?: string
  urlAvatar?: string
}

const NotificationAvatar = ({ userName, userCode, urlAvatar }: NotificationAvatarProps) => {
  const initialLetters = StringUtils.getFirstLettersName(String(userName))
  const url = useMemo(() => {
    if (urlAvatar) return urlAvatar
    if (!userCode) return undefined

    return `${process.env.API_COMMUNITY_GATEWAY}/public/v1/users/${userCode}/image?redirect=true&dimensions=100x100`
  }, [urlAvatar, userCode])

  return (
    <Avatar
      data-test='notification-img'
      className='_bg-blue _text-white'
      urlAvatar={url}
      initialLetters={initialLetters}
      size='lg'
    />
  )
}

export default NotificationAvatar
